import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const MyFilesListSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap>
			<div className="flex justify-between items-center">
				<GovSkeleton
					width="170px"
					height="23px"
					color="neutral"
					aria-label={t('loading.wcag.processing')}
					className="mr-auto"
				/>
				<div className="flex">
					<div className="w-[120px]">
						<GovSkeleton
							width="60px"
							height="23px"
							color="neutral"
							aria-label={t('loading.wcag.processing')}
							className="hidden [ md:inline ]"
						/>
					</div>
					<GovSkeleton
						width="80px"
						height="23px"
						color="neutral"
						aria-label={t('loading.wcag.processing')}
						className="ml-2"
					/>
				</div>
			</div>
			{generateArrayFromLength(5).map((i) => (
				<div
					className="pb-4 border-b border-(--border-subtlest) [ last-of-type:border-0 ]"
					key={i}>
					<div className="flex justify-between items-center">
						<div className="w-3/4 mr-auto">
							<GovSkeleton
								width={generateRandomNumber(50, 240) + 'px'}
								height="21px"
								color="neutral"
								aria-label={t('loading.wcag.processing')}
							/>
						</div>
						<GovSkeleton
							width="130px"
							height="21px"
							color="neutral"
							aria-label={t('loading.wcag.processing')}
							className="hidden [ md:inline ]"
						/>
						<GovSkeleton
							width="24px"
							height="24px"
							color="neutral"
							aria-label={t('loading.wcag.processing')}
							className="ml-11 mr-3"
						/>
					</div>
					<div>
						<GovSkeleton
							width={generateRandomNumber(30, 70) + '%'}
							height="14px"
							color="neutral"
							aria-label={t('loading.wcag.processing')}
						/>
					</div>
				</div>
			))}
			<span className="flex gap-1.5">
				{generateArrayFromLength(10).map((i) => (
					<GovSkeleton
						key={i}
						width="40px"
						height="40px"
						color="neutral"
						aria-label={t('loading.wcag.processing')}
					/>
				))}
			</span>
		</LayoutGap>
	);
};
